import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import type { FLEXIBLE_DURATION_RANGE } from 'constants/search'
import { useIntl } from 'react-intl'
import type { DurationOption } from './DurationPicker'
import DurationPicker from './DurationPicker'
import MonthPicker from './MonthPicker'

interface Props {
  onDurationChange?: (duration: FLEXIBLE_DURATION_RANGE) => void
  onMonthChange?: (monthOptions: string) => void
  onDatesChange?: () => void
  previouslySelectedDuration?: FLEXIBLE_DURATION_RANGE
  previouslySelectedMonths?: string
  durationOptionsCustom?: Array<DurationOption>
  showYearSelector?: boolean
  useExactHotelDurations?: boolean
}

function FlexibleDatePicker(props: Props) {
  const {
    onDurationChange,
    onMonthChange,
    previouslySelectedDuration,
    previouslySelectedMonths,
    durationOptionsCustom,
    showYearSelector,
    useExactHotelDurations,
  } = props
  const intl = useIntl()
  return (
    <Group direction="vertical" gap={24} horizontalAlign="center">
      <Group direction="vertical" gap={16} horizontalAlign="center">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'xFtiiq0QmRplZUNvwWbF',
            defaultMessage: 'How long?',
          })}
        </Heading>
        <DurationPicker
          durationOptionsCustom={durationOptionsCustom}
          previouslySelectedDuration={previouslySelectedDuration}
          onDurationChange={onDurationChange}
          useExactHotelDurations={useExactHotelDurations}
        />
      </Group>
      <Group direction="vertical" gap={16} horizontalAlign="center">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'VZI1AkaAOxtG_f7mac_2',
            defaultMessage: 'When?',
          })}
        </Heading>
        <MonthPicker
          previouslySelectedMonths={previouslySelectedMonths}
          onMonthChange={onMonthChange}
          showYearSelector={showYearSelector}
        />
      </Group>
    </Group>
  )
}

export default FlexibleDatePicker
